<template>
  <div class="p-kao " id="p-kao" v-if="checkContent">
    <div class="h11 position-relative" id="p-kao-1"></div>
    <div class="b-title d-flex align-items-center">
      考核信息
    </div>
    <div class="bg-white p-body px-3 mb-3">{{checkContent}}</div>
  </div>
</template>

<script>
  export default {
    name: "advKao",
    props: [
      'checkContent'
    ]
  }
</script>

<style scoped>

</style>
